<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="openPage('/blog')" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <div class="row justify-content-center mt-30">
          <div class="col-sm-10">
            <form @submit.prevent="validateRegister">
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="blog_name">Title</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input id="blog_name" v-model="blog_name" name="name" v-validate="'required'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('name') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Author</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="author" name="author" type="text"></b-form-input>
                  <!-- v-validate="'required'"
                  <span class="error">{{ errors.first('author') }}</span> -->
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Tags</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="tags" name="tags" type="text"></b-form-input>
                  <!-- v-validate="'required'"
                  <span class="error">{{ errors.first('tags') }}</span> -->
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Category</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <b-form-select name="category" v-model="category">
                      <option :value="null">Please select</option>
                      <option v-for="item in optCategory" :key="item.id" :value="item.id">{{item.name}}</option>
                    </b-form-select>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="image_blog">Image</label>
                </b-col>
                <b-col sm="10">
                  <b-form-file name="file" @change="previewImage" accept="image/*" v-model="file" :state="Boolean(file)" placeholder="Choose a file..."></b-form-file>
                  <!-- <div class="mt-3">Selected file: {{file && file.name}}</div> -->
                  <div class="image-preview" v-if="imageData.length > 0">
                      <img class="preview" :src="imageData">
                  </div>
                  <!-- v-validate="'required'"
                  <span class="error">{{ errors.first('file') }}</span> -->
                </b-col>
              </b-row>
              <div class="font-bold">ENGLISH</div>
              <hr class="mt-5">
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="status_blog">Short Description</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <quill-editor class="editor-custom" name="shor_description_en" ref="myTextEditor" v-model="short_description_en" :config="editorOption"></quill-editor>
                  </div>
                  <!-- v-validate="'required'"
                  <span class="error">{{ errors.first('shor_description_en') }}</span> -->
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="status_blog">Description</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <quill-editor class="editor-custom" name="description_en" ref="myTextEditor" v-model="description_en" :config="editorOption"></quill-editor>
                  </div>
                  <!-- v-validate="'required'"
                  <span class="error">{{ errors.first('description_en') }}</span> -->
                </b-col>
              </b-row>
              <div class="font-bold">INDONESIA</div>
              <hr class="mt-5">
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="status_blog">Short Description</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <quill-editor class="editor-custom" name="shor_description_id" ref="myTextEditor" v-model="short_description" :config="editorOption"></quill-editor>
                  </div>
                  <!-- v-validate="'required'"
                  <span class="error">{{ errors.first('shor_description_id') }}</span> -->
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="status_blog">Description</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <quill-editor class="editor-custom" name="description_id" ref="myTextEditor" v-model="description" :config="editorOption"></quill-editor>
                  </div>
                  <!-- v-validate="'required'"
                  <span class="error">{{ errors.first('description_id') }}</span> -->
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="status_gallery">Status</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <b-form-select name="status" v-validate="'required'" v-model="selected" :options="options" class="mb-3" />
                  </div>
                  <span class="error">{{ errors.first('status') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="status_gallery">News</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <b-form-select name="news" v-model="is_news_selected" :options="is_news" class="mb-3" />
                  </div>
                  <span class="error">{{ errors.first('news') }}</span>
                </b-col>
              </b-row>
              <div class="text-right">
                <button type="submit" class="btn-primary">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import { quillEditor } from 'vue-quill-editor'

export default {
  name: 'addBlog',
  data: function () {
    return {
      editorOption: {
        // modules: {
        //   toolbar: [
        //     ['bold', 'italic', 'underline', 'strike'],
        //     ['blockquote', 'code-block'],
        //     [{ 'header': 1 }, { 'header': 2 }, { 'header': 3 }], 
        //   ]
        // }
      },
      optCategory: [],
      description: '',
      description_en: '',
      short_description: '',
      short_description_en: '',
      blog_name: '',
      author: '',
      tags: '',
      category: null,
      imageData: '',
      file: null,
      selected: null,
      options: [
        { value: null, text: 'Please select' },
        { value: 'active', text: 'Active' },
        { value: 'inactive', text: 'Inactive' }
      ],
      is_news_selected: 0,
      is_news: [
        { value: 0, text: 'No' },
        { value: 1, text: 'Yes' }
      ]
    }
  },
  components: {
    quillEditor
  },
  methods: {
    // onEditorChange(event) {
    //   console.log('onEditorChange')
    // },
    validateRegister () {
      this.$validator.validateAll().then((result) => {
        if(result) {
          axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
          axios.defaults.headers.post['Content-Type'] = 'multipart/form-data'
          var data = new FormData()
          data.append('photos', this.file)
          data.append('title', this.blog_name)
          data.append('author', this.author)
          data.append('tags', this.tags)
          data.append('blog_category_id', this.category)
          data.append('description', this.description)
          data.append('description_en', this.description_en)
          data.append('short_description', this.short_description)
          data.append('short_description_en', this.short_description_en)
          data.append('status', this.selected)
          data.append('is_news', this.is_news_selected)
          axios.post('compro/v1/blog/', data).then(response => {
            // console.log('test', response)
            this.$router.push('/blog')
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }).catch(error => {
            // console.log('error', error)
            this.$toast.success('cant saved data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    openPage (event) {
      this.$router.push(event)
    },
    previewImage: function(event) {
        // Reference to the DOM input element
        var input = event.target;
        // Ensure that you have a file before attempting to read it
        if (input.files && input.files[0]) {
            // create a new FileReader to read this image and convert to base64 format
            var reader = new FileReader();
            // Define a callback function to run, when FileReader finishes its job
            reader.onload = (e) => {
                // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                // Read image as base64 and set to imageData
                this.imageData = e.target.result;
            }
            // Start the reader job - read file as a data url (base64 format)
            reader.readAsDataURL(input.files[0]);
        }
    },
    fetchData() {
      axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
      axios.get('compro/v1/blog_category').then(response => {
        this.optCategory = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style lang="scss" scoped>
</style>
